import React from 'react';

type BizSpinnerProps = {
	size?: '1x' | '2x' | '3x' | '4x' | '5x';
};

const BizSpinner = ({ size }: BizSpinnerProps) => {
	return <i className={`fad fa-spinner-third fa-spin fa-${size ?? '1x'}`}></i>;
};

export default BizSpinner;
